
import styled from 'styled-components'
import SingleRouteMap from '../../map/SingleRouteMap'
import { IoMdClose } from "react-icons/io";
import { useSelector } from 'react-redux';
import { showModal, showNestedModal } from '../../../features/modal/modalSlice';
import { useDispatch } from 'react-redux';
import Btn from '../../shared/button/Btn';
import { BsFillExclamationCircleFill } from "react-icons/bs";
import { useState } from 'react';
import InputSelectAdres from '../../shared/input/special/InputSelectAdres';
import { useEffect } from 'react';
import { getAdresAutoComplete, setAdresAutoComplete } from '../../../features/address/addressSlice';
import {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete';
import { setAdresSelectMapZoom, setSelectedRouteItem, updateRouteItem } from '../../../features/addLoad/addLoadSlice';
import { handleActiveSelect } from '../../../features/layout/layoutSlice';
import addLoadLocationData from '../../../utils/locationData/addLoadLocationOptions';
import { BsFillQuestionCircleFill } from "react-icons/bs";

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;
    
  .modal {
    width: auto;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .content {
      width: 650px;
      height: 100%;
      display: flex;
      flex-direction: column;
      
      .top-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        .h2{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-xl);
        }

        .close-icon{
            font-size: 1.4rem;
            cursor: pointer;
            color: ${({theme}) => theme.mainTextColor};
        }
      }

      .desc{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        margin-bottom: 30px;
      }

      .input-container{
        margin-bottom: 20px;
      }

      .exc-container{
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({theme}) => theme.secondaryBgColor};
        padding: 15px 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);

        .exc-icon{
          margin-right: 5px;
          fill: #636161;

        }
      }

      .map-container{
        width: 100%;
        min-width: 400px;
        height: 350px;
      }

      .bottom-container{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;

        .adres-text{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
        }

        .btn-container{
          display: flex;
          align-items: center;
          gap: 5px;

          .question-container{
            position: relative;
            display: flex;
            align-items: center;
            
            .question-icon{
              font-size: 1.4rem;
              cursor: pointer;
              color: #444;
              color: ${({theme, hoveredQuestionText}) => hoveredQuestionText ? theme.mainTextColor : theme.secondaryTextColor };
            }
            .desc-container{
              position: absolute;
              height: auto;
              top: 0;
              right: -170px;
              transform: translate(-50%, -50%);
              width: 400px;
              padding: 10px;
              border-radius: 10px;
              background-color: ${({theme}) => theme.secondaryBgColor};
              
              p{
                line-height: 1.4;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
              }
            }

          }
        }

      }

    }
  }
`

const SingleRouteMapModal = () => {

  const { selectedRouteItem, selectedRouteItemType, route } = useSelector((state) => state.addLoad);
  const {adresAutoCompleteOptions} = useSelector(state => state.address)

  const dispatch = useDispatch()

  const [selected, setSelected] = useState(null)
  const [hoveredQuestionText, setHoveredQuestionText] = useState(false)

    useEffect(()=> {
      if(selectedRouteItem?.locationData?.googleSearchText?.length > 0){
        dispatch(getAdresAutoComplete({searchText: selectedRouteItem?.locationData?.googleSearchText}))
      }
      else{
        dispatch(setAdresAutoComplete([]))
      }
    },[selectedRouteItem?.locationData?.googleSearchText])

    useEffect(() => {
      if(selected){
        getCoordinates(selected.description)
      }
    },[selected])

    const getCoordinates = async() => {
      try {
        const results = await getGeocode({ address:selected.description });
        const { lat, lng } = await getLatLng(results[0]);
        
        dispatch(setSelectedRouteItem({...selectedRouteItem, locationData: {...selectedRouteItem?.locationData, googleLat: lat, googleLng: lng, googleSearchText: selected.description, googleLocation: selected.description, isfirstChanged: true }}));
        dispatch(setAdresSelectMapZoom(12))
      } 

      catch (error) {
          // console.log(error);
      }
    }

    const handleSubmit = () => {

      //! route içinden ilgili routeItem 
      const currentItem = route.find(item => item.id === selectedRouteItem?.id)

      const locationItem = addLoadLocationData.find(item => {
        return selectedRouteItem?.locationData?.googleLocation.includes(item.city) && selectedRouteItem?.locationData?.googleLocation.includes(item.town)
      })

      
      dispatch(updateRouteItem({...selectedRouteItem,
        adres: !currentItem?.adres ? selectedRouteItem?.locationData?.googleLocation : currentItem?.adres,
        locationData: {
        ...selectedRouteItem?.locationData,
        // il: currentItem?.locationData?.location ? currentItem.locationItem?.il : locationItem?.city,
        // ilId: currentItem?.locationData?.ilId ? currentItem?.locationData?.ilId : locationItem?.cityId,
        // ilce: currentItem?.locationData?.ilce ? currentItem?.locationData?.ilce : locationItem?.town,
        // ilceId: currentItem?.locationData?.ilceId ? currentItem?.locationData?.ilceId : locationItem?.townId,
        // bolge: currentItem?.locationData?.bolge ? currentItem?.locationData?.bolge : locationItem?.region,
        // location: currentItem?.locationData?.location ? currentItem?.locationData?.location : locationItem?.location,

        il: locationItem?.city,
        ilId: locationItem?.cityId,
        ilce: locationItem?.town,
        ilceId: locationItem?.townId,
        bolge: locationItem?.region,
        location: locationItem?.location,

        isGoogleAddressSelected: true,
        lat: selectedRouteItem?.locationData?.googleLat,
        lng: selectedRouteItem?.locationData?.googleLng,
        googleLat: selectedRouteItem?.locationData?.googleLat,
        googleLng: selectedRouteItem?.locationData?.googleLng,
        googleLocation: selectedRouteItem?.locationData?.googleLocation
       }}));

       dispatch(showModal(null))
       dispatch(setSelectedRouteItem(null))
       dispatch(setAdresAutoComplete([]))

    } 


    const handleClose = () => {

      const currentItem = route.find(item => item.id === selectedRouteItem.id)

      if(
        currentItem?.locationData?.il === selectedRouteItem?.locationData?.il &&
        currentItem?.locationData?.ilId === selectedRouteItem?.locationData?.ilId &&
        currentItem?.locationData?.ilce === selectedRouteItem?.locationData?.ilce &&
        currentItem?.locationData?.ilceId === selectedRouteItem?.locationData?.ilceId &&
        currentItem?.locationData?.lat === selectedRouteItem?.locationData?.lat &&
        currentItem?.locationData?.lng === selectedRouteItem?.locationData?.lng &&
        currentItem?.locationData?.googleLat === selectedRouteItem?.locationData?.googleLat &&
        currentItem?.locationData?.googleLng === selectedRouteItem?.locationData?.googleLng &&
        currentItem?.locationData?.googleLocation === selectedRouteItem?.locationData?.googleLocation &&
        currentItem?.locationData?.location === selectedRouteItem?.locationData?.location &&
        currentItem?.locationData?.ilce === selectedRouteItem?.locationData?.ilce
      ){
        dispatch(showModal(null))
        dispatch(setSelectedRouteItem(null))
        dispatch(setAdresAutoComplete([]))
      }
      else{
        dispatch(showNestedModal("addLoadRouteItemNotSavedDesc"))
      }
    }
    
    const handleTextChange = (e) => {

      dispatch(setSelectedRouteItem({...selectedRouteItem, locationData: {...selectedRouteItem?.locationData, googleSearchText: e?.target?.value }}))
    }

    
  return (
    // <Container>
    <Container onClick={handleClose} hoveredQuestionText={hoveredQuestionText}>
        <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <div className="top-container">
                    <h2 className='h2'>Tam konumunuz nedir?</h2>
                    <IoMdClose className='close-icon' onClick={handleClose}/>
                </div>
                <p className="desc">Tam Konum girmeniz sorunsuz sevkiyat işlemi ve sefer konum takibi için önemlidir.</p>
                <div className="input-container">
                    <InputSelectAdres text={selectedRouteItem?.locationData?.googleSearchText} setText={(e) => handleTextChange(e)} selected={selected} setSelected={setSelected} labelText={"Adres Girin"} options={adresAutoCompleteOptions} inputWidth={"100%"}/>
                </div>
                <div className="exc-container">
                  <BsFillExclamationCircleFill className='exc-icon'/>
                  Haritada imleci {selectedRouteItemType ? "Yükleme" : "Boşaltma"} noktasına getirin
                </div>
                <div className="map-container">
                    <SingleRouteMap/>
                </div>
                <div className="bottom-container">
                  <span className='adres-text'>{selectedRouteItem?.locationData?.googleLocation ? `Seçilen Adres: ${selectedRouteItem?.locationData?.googleLocation}` : "Adres Girin"}</span>
                  <div className="btn-container">
                    <div className="question-container">
                      
                      <BsFillQuestionCircleFill className='question-icon' onMouseEnter={() => setHoveredQuestionText(true)} onMouseLeave={() => setHoveredQuestionText(false)}/>
                        {
                          hoveredQuestionText &&
                          <div className="desc-container">
                            <p>Eğer adres girmediyseniz, haritadan seçilen konum adrese aktarılacaktır. Aktarılan bu adresi değiştirebilirsiniz. Kaydedilen adres resmi yükleme/boşaltma adresi olarak kullanılacaktır. Kaydedilen konum ise sürücünün gideceği konum olarak kullanılacaktır.</p>
                          </div>
                        } 
                    </div>
                    <Btn color='#fff' bgColor={selectedRouteItem?.locationData?.googleLocation ? '#E85446' : '#7c7b7b'} isDisabled={!selectedRouteItem?.locationData?.googleLocation} handleClick={handleSubmit} borderColor='none' width={"140px"}>Bu Adresi Kullan</Btn>
                  </div>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default SingleRouteMapModal